<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>
      <SubHeaderWithSidebar :title="headerTitle" />

      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="survivorWrap_start livepollWrap">
            <div class="icon">
              <img src="@/assets/img/poll_icon.png" alt="Survivor" />
            </div>
            <p>
              이번 {{itemTitle}}는
              <span>{{itemMeta.index}}</span>번 입니다
              <br />스크린의 문제를 확인하세요!
            </p>
            <a href @click.prevent="goDisable" title class="disable">
              <span>
                <img src="@/assets/img/check.png" alt />
              </span>
              {{waitmsg}}은 1회만 제출가능합니다.
            </a>
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
      <footer>
        <div class="logo">
          <img src="@/assets/img/logo.png" alt="weliveOn" />
        </div>
      </footer>
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import sideMixin from "@/components/SideMixin";
export default {
  mixins: [sideMixin],
  components: { SubHeaderWithSidebar },
  computed: {
    itemMeta() {
      return this.$store.state.itemMeta;
    },
    itemTitle() {
      return this.$store.state.itemMeta.item_type === "quiz" ? "퀴즈" : "설문";
    },
    waitmsg() {
      return this.$store.state.itemMeta.item_type === "quiz" ? "정답" : "의견";
    },
    headerTitle() {
      return this.$store.state.itemMeta.item_type === "quiz"
        ? "Live Quiz"
        : "Live Poll";
    }
  },
  methods: {
    goDisable() {}
  }
};
</script>


<style lang="scss" scoped>
</style>